
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/CopyCourse';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n      <div class=\"controls importQuizzesNext\"></div>\n  ";
  }

  buffer += "<div class=\"control-group courseFindSelect\"></div>\n<div class=\"control-group content\">\n  <label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.copy_course")
  },data:data},helper ? helper.call(depth0, "content_migrations.copy_course.content", "Content", options) : helperMissing.call(depth0, "t", "content_migrations.copy_course.content", "Content", options)))
    + "</strong></label>\n  <div class=\"controls selectContent\"></div>\n</div>\n<div class=\"control-group options\">\n  <label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.copy_course")
  },data:data},helper ? helper.call(depth0, "content_migrations.copy_course.options", "Options", options) : helperMissing.call(depth0, "t", "content_migrations.copy_course.options", "Options", options)))
    + "</strong></label>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.new_quizzes_migration), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n   <div class=\"dateShift\"></div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  